import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { Typography, Checkbox } from "@mui/material";
import axios from "axios";
import AuthHeader from "../../../../Auth";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import UnLock from "../../../../GlobalFunction/UnLock";
import axiosInstance from "../../../../lib/axios";

const UserStep1 = ({
  UserData,
  Mode,
  Index,
  UserTypeNameData,
  AllTextDisabled,
  AllButtonDisabled,
  viewMode,
  UserId,
  setMode,
  fetchUserData,
  setAllTextDisabled,
  setAllButtonDisabled,
  handleStepClick,
  UserLoginId,
}) => {
  const [formData, setFormData] = useState({
    UtId: "",
    UserName: "",
    Pwd: "",
    MobileNo: "",
    EmailId: "",
    Remark: "",
  });

  useEffect(() => {
    if (Mode === "view" && UserTypeNameData.length > 0) {
      const selectedUser = UserData[Index];
      console.log("selecteduser", selectedUser);
      setFormData({
        UtId: selectedUser.UtId,
        UserName: selectedUser.UserName,
        Pwd: selectedUser.Pwd,
        MobileNo: selectedUser.MobileNo,
        EmailId: selectedUser.EmailId,
        Remark: selectedUser.Remark,
        Status: selectedUser.Status,
      });
    } else if (Mode === "add") {
      resetFunc();
    }
  }, [UserData, Mode, Index, UserTypeNameData]);

  const resetFunc = () => {
    setFormData({
      UtId: "",
      UserName: "",
      Pwd: "",
      MobileNo: "",
      EmailId: "",
      Remark: "",
      Status: "1",
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log(name, value);
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleCancel = async () => {
    if (UserId != -1) {
      if (Mode === "view") {
        await UnLock(UserId, "MstUser", "UserId");
      }
      viewMode();
      setMode("view");
    } else {
      // setMode("add");
      // viewMode();
      await fetchUserData(1, "L");
    }
  };

  const handleNextClick = () => {
    handleStepClick(1);
  };
  const handleClickSubmit = async () => {
    if (
      formData.UtId === "" ||
      formData.UserName === "" ||
      formData.Pwd === ""
    ) {
      toast.info("Please Filled The Required Field");
      return;
    } else if (formData.Pwd && formData.Pwd.length > 12) {
      toast.info("Password Should Be Less Than 12 Character");
      return;
    }
    if (!/^[0-9]{10}$/.test(formData.MobileNo)) {
  toast.error("Mobile number must be exactly 10 digits");
  return;
}

    if (Mode === "add") {
      formData.CreatedBy = parseInt(UserLoginId);
      try {
        const response = await axiosInstance.post(
          `UserMst/InsertUserMst`,
          formData,
        );

        if (response.data.Status === 0) {
          toast.success(response.data.Message, { autoClose: 1000 });
          fetchUserData(response.data.Data, "R");
          // setAllTextDisabled(prev => !prev);
          // setAllButtonDisabled(prev => !prev);
        } else {
          toast.info(response.data.Message, { autoClose: 1000 });
        }
      } catch (err) {
        console.log("err", err);
      }
    } else {
      formData.UpdatedBy = parseInt(UserLoginId);
      formData.UserId = UserId;
      try {
        const response = await axiosInstance.post(
          `UserMst/UpdateUserMst`,
          formData,
        );

        if (response.data.Status === 0) {
          // toast.success(response.data.Message, { autoClose: 1000 });
          // toast.success(response.data.Message, { autoClose: 1000 });
          toast.success(response.data.Message, { autoClose: 1000 });
          await UnLock(UserId, "MstUser", "UserId");
          await fetchUserData(UserId, "R");
          // setAllTextDisabled(prev => !prev);
          // setAllButtonDisabled(prev => !prev);
        } else {
          toast.error(response.data.Message, { autoClose: 1000 });
        }
      } catch (err) {
        console.log("err", err);
      }
    }
  };
  const handleCheckBoxChange = (e) => {
    console.log(e.target.name);
    const { name, value } = e.target;
    console.log(value);
    if (formData.Status === "1") {
      setFormData((prevData) => ({ ...prevData, [name]: "0" }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: "1" }));
    }
  };

  return (
    <>
      <Box>
        {/* <ToastContainer /> */}
        <Grid item xs={12} className="form_field" sx={{ marginTop: "2px" }}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={4}>
              {/* <FormControl variant="filled" fullWidth className="custom-select">
          
              <Select
                labelId="user-type-label"
                id="UtId"
               
                name="UtId"
                value={formData.UtId}
                onChange={handleInputChange}
                sx={{ height: 41, lineHeight: '1.5', padding: '8px 16px',  marginTop:"-10px" }}
                disabled={AllTextDisabled}
              >
                {UserTypeNameData?.map((type) => (
                  <MenuItem key={type.Id} value={type.Id}>
                    {type.Name}
                  </MenuItem>
                ))}

              </Select>
            </FormControl> */}
              <FormControl variant="filled" fullWidth className="custom-select">
                <InputLabel id="companyName-select-label">
                  <span>
                    User Type <span style={{ color: "red" }}>*</span>
                  </span>
                </InputLabel>
                <Select
                  labelId="companyName-select-label"
                  id="UtId"
                  name="UtId"
                  value={formData.UtId}
                  onChange={handleInputChange}
                  className="custom-textfield"
                  disabled={AllTextDisabled}
                >
                  {UserTypeNameData?.map((type) => (
                    <MenuItem key={type.Id} value={type.Id}>
                      {type.Name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <TextField
                id="UserName"
                name="UserName"
                label={
                  <span>
                    User Name <span style={{ color: "red" }}>*</span>
                  </span>
                }
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={formData.UserName}
                onChange={handleInputChange}
                disabled={AllTextDisabled}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          spacing={1}
          sx={{ marginTop: "2px" }}
          className="form_field"
        >
          <Grid container spacing={1}>
            <Grid item xs={12} md={4} lg={4}>
              <TextField
                id="Pwd"
                name="Pwd"
                type="password"
                label={
                  <span>
                    Password <span style={{ color: "red" }}>*</span>
                  </span>
                }
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={formData.Pwd}
                onChange={handleInputChange}
                disabled={AllTextDisabled}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <TextField
                id="MobileNo"
                name="MobileNo"
                label={
                  <span>
                    Mobile<span style={{ color: "red" }}>*</span>
                  </span>
                }
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={formData.MobileNo}
                onChange={handleInputChange}
                disabled={AllTextDisabled}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "2px" }} className="form_field">
          <Grid container spacing={1}>
            <Grid item xs={12} md={4} lg={4}>
              <TextField
                id="EmailId"
                name="EmailId"
                label={
                  <span>
                    Email Id<span style={{ color: "red" }}>*</span>
                  </span>
                }
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={formData.EmailId}
                onChange={handleInputChange}
                disabled={AllTextDisabled}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <TextField
                id="Remark"
                name="Remark"
                label="Remark"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={formData.Remark}
                onChange={handleInputChange}
                disabled={AllTextDisabled}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={AllTextDisabled}
                      name="Status"
                      checked={formData.Status === "1" ? true : false}
                      onChange={handleCheckBoxChange}
                    />
                  }
                  label="Status"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <Grid item xs={12} className="form_button">
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
          }}
          onClick={handleNextClick}
          disabled={AllTextDisabled}
        >
          Next
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
          }}
          onClick={handleClickSubmit}
          disabled={AllTextDisabled}
        >
          submit
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            mr: 1,
            background: "linear-gradient(290deg, #b9d0e9, #e9f2fa)",
          }}
          onClick={handleCancel}
          disabled={AllTextDisabled}
        >
          Cancel
        </Button>
      </Grid>
    </>
  );
};

export default UserStep1;
